import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../../lib/utils";
import { Label } from "../label";

const formFieldVariants = cva("flex flex-col gap-1", {
  variants: {
    layout: {
      default: "mb-4",
      inline: "mb-0",
    },
    width: {
      full: "w-full",
      staff: "w-[60%] max-md:w-full",
    },
  },
  defaultVariants: {
    layout: "default",
    width: "full",
  },
});

function FormField({
  label,
  htmlFor,
  required,
  hint,
  layout,
  width,
  className,
  labelSize = "default",
  children,
}) {
  return (
    <div className={cn(formFieldVariants({ layout, width }), className)}>
      {label && (
        <Label htmlFor={htmlFor} size={labelSize}>
          {label}
          {required && <span className="text-[#ef4444]"> *</span>}
        </Label>
      )}
      {children}
      {hint && <span className="mt-1 text-xs text-slate-400">{hint}</span>}
    </div>
  );
}

export { FormField, formFieldVariants };
